import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, FestivalHeader, FormRow } from '../controls';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import { useSendPushNotificationMutation } from '@/queries/push/useSendPushNotificationMutation';

function PushNotificationsForm({ sendMutation }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: { text: '' },
    mode: 'onSubmit',
  });

  const onSubmit = (values) => {
    sendMutation.mutate(values, {
      onSuccess: () => {
        reset({ text: '' });
      },
    });
  };

  return (
    <>
      <FestivalHeader title="Push Notification" />
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormRow label="Message" error={errors.text?.message}>
          <textarea
            placeholder="Message"
            {...register('text', { required: 'Message is required' })}
          />
        </FormRow>
        <Button style={{ float: 'right' }} type="submit">
          Send Notification
        </Button>
      </form>
    </>
  );
}

function PushNotificationsReady({ festivalId }) {
  const sendMutation = useSendPushNotificationMutation(festivalId);
  return <PushNotificationsForm sendMutation={sendMutation} />;
}

export default function PushNotifications() {
  const festival = useFestivalWorkspaceStore((s) => s.festival);
  const festivalId = festival?.festivalId;

  if (!festivalId) {
    return (
      <>
        <FestivalHeader title="Push Notification" />
        <p className="p-6 text-gray-600">Select a festival first.</p>
      </>
    );
  }

  return <PushNotificationsReady festivalId={festivalId} />;
}
